module.exports = __webpack_public_path__ + "static/img/logo83.d56683d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo83.png
// module id = i60l
// module chunks = 1